import React, { Component } from 'react'
import style from './style.module.less'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Drawer, Input, Button, Spin } from 'hljd'
import Store from './store'
import { observer } from 'mobx-react'
import Img from '@UI/Img'
import {
  PRIVILEGE_STORE_ID,
  PRIVILEGE_STORE_SERVICE_ID,
  IMG_LOGO
} from '@constant'
import { Auth } from '@common/Auth'
import { dGet } from '@core/utils'
import { Flex } from 'hljd'
import cls from 'classnames'
import { goToInsertCustomer } from '@util'

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    const {
      drawerVisible,
      toggleDrawer,
      searchCustomerByPhone,
      reset,
      customerDetail,
      loading,
      hasCustomer,
      warningText,
      onChange,
      searchText,
      searched,
      check,
      markThenCheck
    } = this.store

    const {
      nick,
      weddingday,
      appointment_time,
      user_name,
      gender,
      merchant_support
    } =
      customerDetail || {}

    return (
      <>
        <div className={style.checkIn} onClick={toggleDrawer}>
          <a>客户登记</a>
          <img src="//qnm.hunliji.com/o_1d0r56ps41vtg1a8r11671ogs1f2d9.png" />
        </div>

        <Drawer
          width={418}
          title="到店登记"
          placement="right"
          onClose={toggleDrawer}
          visible={drawerVisible}
        >
          <div className={style.title}>已经预约或使用过婚礼纪</div>
          <div className={style.searchArea}>
            <Input
              placeholder="请输入手机号码"
              onChange={onChange}
              value={searchText}
              style={{ marginRight: 20 }}
            />
            <Button
              className={style.searchAreaButton}
              type="primary"
              onClick={searchCustomerByPhone}
            >
              查询
            </Button>

            {searched && (
              <Button
                className={style.searchAreaButton}
                onClick={reset}
                style={{ marginLeft: 10 }}
              >
                重置
              </Button>
            )}
          </div>
          <Spin spinning={loading}>
            {warningText && (
              <Flex className={style.warning} vc>
                <InfoCircleOutlined
                  style={{ color: '#FF705E', marginRight: 3 }}
                />
                <span>未查询到预约或婚礼纪账号，请手动录入</span>
              </Flex>
            )}

            {hasCustomer && (
              <div className={style.item}>
                <div className={style.content}>
                  <div className={style.avatarArea}>
                    <Img
                      className={style.avatar}
                      style={{ width: 40, height: 40 }}
                      src={dGet(customerDetail, 'avatar', IMG_LOGO)}
                    />

                    {gender && (
                      <i
                        className={cls(
                          'icon',
                          'iconfont',
                          gender == 1
                            ? 'icon-nan'
                            : gender == 2
                              ? 'icon-nv'
                              : '',
                          style.gender
                        )}
                      />
                    )}
                  </div>

                  <div className={style.info}>
                    <div>
                      <span className={style.value} style={{ marginRight: 20 }}>
                        {user_name || nick}
                      </span>
                      <span>
                        <span className={style.label}>负责人：</span>
                        <span className={style.value}>
                          {merchant_support && merchant_support.length
                            ? merchant_support.map(item => item.nick).join('、')
                            : '无'}
                        </span>
                      </span>
                    </div>

                    <div>
                      <span style={{ marginRight: 20 }}>
                        <span className={style.label}>婚期：</span>
                        <span className={style.value}>
                          {weddingday || '无'}
                        </span>
                      </span>
                      <span>
                        <span className={style.label}>预约到店：</span>
                        <span className={style.value}>
                          {appointment_time || '无'}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className={style.action}>
                  <Button onClick={check} style={{ marginRight: 10 }}>
                    查看详情
                  </Button>
                  <Button type="primary" onClick={markThenCheck}>
                    确认到店并查看
                  </Button>
                </div>
              </div>
            )}
          </Spin>

          {(!hasCustomer || !searched) && (
            <>
              {!searched && (
                <div className={style.title} style={{ marginTop: 40 }}>
                  新客户
                </div>
              )}

              <Button
                type="primary"
                onClick={() => {
                  goToInsertCustomer(searchText)
                }}
                style={{ width: '100%' }}
              >
                录入客户
              </Button>
            </>
          )}
        </Drawer>
      </>
    )
  }
}
